import { lazy, Suspense } from 'react';

const TiptapEditorComponent = lazy(() =>
   import('./tiptap').then(module => ({ default: module.TiptapEditor }))
);

export const TiptapEditor = (props: any) => (
   <Suspense
      fallback={
         <div
            id={props.editorid}
            className="ProseMirror-menubar-wrapper min-h-[150px] rounded-md border border-gray-200 bg-gray-50"
         />
      }
   >
      <TiptapEditorComponent {...props} />
   </Suspense>
);
